import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter, IonFooter, IonCheckbox, IonPopover } from '@ionic/react'
import { MktButton, UseSwitchTab, UserNameInput, PrivacyAgreementModal, ServiceAgreementModal, PowerByEShine, AgreementCheck } from '@cps'
import { localStore, getParams, validMobileOrMail } from '@dt/fe-utils'
import { modalLayer, toast, useHistoryNew } from '@utils'
import { FacebookProvider, LoginButton } from 'react-facebook'
import { GoogleLogin as GoogleLoginOuth, GoogleLoginResponse } from 'react-google-login'
import { GoogleLogin as GoogleLoginOuth2, GoogleOAuthProvider, CredentialResponse } from '@react-oauth/google'
import { memberMobx, storeMobx } from '@mobxStore'
import MktController from 'controllers/mktController'
import i18n from 'i18next'
import './index.scss'

import ggImg from '@img/mkt/google.png'
import fbImg from '@img/mkt/facebook.png'

// interface
interface IProps extends IPage, RouteComponentProps {
}

const Login: FC<IProps> = (props) => {
  const loginPgaePara = getParams()
  const { state } = props.location
  if (loginPgaePara.cardNo && loginPgaePara.cardPin && loginPgaePara.ordersId && loginPgaePara.type) {
    const bindGcInfo = localStore.get(memberMobx.bindGiftCardKey)
    if (bindGcInfo) {
      if (bindGcInfo.cardNo !== loginPgaePara.cardNo) {
        localStore.set(memberMobx.bindGiftCardKey, {
          cardNo: loginPgaePara.cardNo,
          cardPin: loginPgaePara.cardPin,
          ordersId: loginPgaePara.ordersId,
          type: loginPgaePara.type,
        })
      }
    } else {
      localStore.set(memberMobx.bindGiftCardKey, {
        cardNo: loginPgaePara.cardNo,
        cardPin: loginPgaePara.cardPin,
        ordersId: loginPgaePara.ordersId,
        type: loginPgaePara.type,
      })
    }
  }
  if (loginPgaePara.giveId) {
    const giveKey = localStore.get(memberMobx.receiveCouponKey)
    if (giveKey) {
      if (giveKey !== Number(loginPgaePara.giveId)) {
        localStore.set(memberMobx.receiveCouponKey, Number(loginPgaePara.giveId))
      }
    } else {
      localStore.set(memberMobx.receiveCouponKey, Number(loginPgaePara.giveId))
    }
  }
  if (loginPgaePara.acquireByConsumeSendCoupon) {
    localStore.set(memberMobx.consumeCouponsKey, {
      ordersId: loginPgaePara.acquireByConsumeSendCoupon,
      activityId: loginPgaePara.activityId
    })
  }
  const history = useHistoryNew()
  const { brand } = storeMobx
  const [types, setTypes] = useState<any[]>([])
  const [type, setType] = useState<string>()
  const [correctAccount, setCorrectAccount] = useState<boolean>(true)
  const [keep, setKeep] = useState<boolean>(true)
  const [userNameInfo, setUserNameInfo] = useState<any>({})
  const [showPopover, setShowPopover] = useState<boolean>(false)
  const [popoverEvent, setPopoverEvent] = useState<any>(undefined)
  const [checked, setChecked] = useState<boolean>(false) // 是否勾选隐私协议
  // Data Method
  const initData = () => {
    const typesArr = window.bo !== 'cn' ? [
      { value: 'mobile', label: i18n.t('mkt.common.mobile') },
      { value: 'email', label: i18n.t('mkt.common.email') }
    ] : [
      { value: 'mobile', label: i18n.t('mkt.common.mobile') }
    ]
    setTypes(typesArr)
    setType(typesArr[0].value)
    // setUserNameInfo({})
    setUserNameInfo(
      (state as any)?.contactMobile ? (
        {
          inputValue: (state as any)?.contactMobile,
          countryCode: Number((state as any)?.countryCode),
          valid: validMobileOrMail(type as any, (state as any)?.contactMobile, (state as any)?.countryCode)
        }
      ) : {}
    )
  }
  // Component Event
  const handleReg = () => {
    if (!userNameInfo.inputValue || !userNameInfo.valid) {
      setCorrectAccount(false)
      return
    }
    if (agreementJudge && !checked) {
      toast({ message: i18n.t('mkt.common.tipPrivacy') })
      return
    }
    const para: any = {}
    if (type === 'email') {
      para.email = userNameInfo.inputValue
    } else if (type === 'mobile') {
      para.mobile = userNameInfo.inputValue
      para.countryCode = userNameInfo.countryCode
    }
    memberMobx.checkAccount(para).then((res: any) => {
      if (res) {
        const isReg: number = res.isRegister ? 1 : 0
        const countryCode: string = userNameInfo.countryCode === '' ? '0' : userNameInfo.countryCode
        history.push('/login/password/' + isReg + '/' + type + '/' + userNameInfo.inputValue + '/' + countryCode)
      }
    })
  }
  const handleNext = () => {
    if (agreementJudge && !checked) {
      toast({ message: i18n.t('mkt.common.tipPrivacy') })
      return
    }
    if (!userNameInfo.inputValue || !userNameInfo.valid) {
      toast({ message: i18n.t(type === 'email' ? 'mkt.common.tipEmail' : 'mkt.common.tipMobile') })
      return
    }
    const para: any = {}
    if (type === 'email') {
      para.email = userNameInfo.inputValue
    } else if (type === 'mobile') {
      para.mobile = userNameInfo.inputValue
      para.countryCode = userNameInfo.countryCode
    }
    memberMobx.checkAccount(para).then((res: any) => {
      if (res) {
        const isReg: number = res.isRegister ? 1 : 0
        const countryCode: string = userNameInfo.countryCode === '' ? '0' : userNameInfo.countryCode
        if (isReg === 1) {
          history.push('/login/verify/' + type + '/' + userNameInfo.inputValue + '/' + countryCode)
        } else {
          history.push('/login/password/' + isReg + '/' + type + '/' + userNameInfo.inputValue + '/' + countryCode)
        }
      }
    })
  }
  const handleFbLogin = (response: IFacebookResponse) => {
    memberMobx.login('facebook', response.profile).then((res: any) => {
      if (res) {
        toast({ message: i18n.t('mkt.common.loginSuccess') })
        MktController.loginEnd(history)
      }
    })
  }
  const handleGgLogin = (outh: 1 | 2, response: any) => {
    if (outh === 1) {
      const realRes: GoogleLoginResponse = response
      memberMobx.login('google', realRes.profileObj).then((res: any) => {
        if (res) {
          toast({ message: i18n.t('mkt.common.loginSuccess') })
          MktController.loginEnd(history)
        }
      })
    } else {
      const realRes: CredentialResponse = response
      memberMobx.login('googleAuth', {
        clientId: realRes.clientId,
        token: realRes.credential
      }).then((res: any) => {
        if (res) {
          toast({ message: i18n.t('mkt.common.loginSuccess') })
          MktController.loginEnd(history)
        }
      })
    }
  }
  const loginError = (error?: any) => {
    console.error('login error:__', error)
  }
  const goBack = () => {
    MktController.goBack(history)
  }
  useIonViewWillEnter(() => {
    if (memberMobx.isLogin) {
      goBack()
      MktController.loginEnd()
    } else {
      initData()
      setKeep(localStore.get(memberMobx.keepSignKey) === 1)
      if (localStore.get(memberMobx.keepSignKey) === 1) {
        sessionStorage.removeItem(memberMobx.keepSignKey)
      } else {
        if (sessionStorage.getItem(memberMobx.keepSignKey) !== '1') {
          sessionStorage.setItem(memberMobx.keepSignKey, '1')
        }
      }
    }
  })
  const handleCheck = () => {
    setChecked(!checked)
  }
  const agreementJudge = boJudge.checkKey('agreement') // bo控制隐私协议模块
  return (
    <IonPage className='login-page'>
      <IonContent className='page-content'>
        <div className='page-header'>
          <div className='left' onClick={goBack}><i className='iconfont icon-BACK-12x'></i></div>
          <div className='brand-area'>
            <div className='brand-logo'>
              <img src={brand.logo || Config.defaultImg.store} alt='' />
            </div>
            <div className='brand-name'>{brand.brandName}</div>
          </div>
        </div>
        <div className='panel'>
          <div className='switch'>
            <UseSwitchTab
              types={types}
              value={type}
              onChange={(value: any) => {
                if (value === type) return
                setType(value)
                setCorrectAccount(true)
              }}
            />
          </div>
          <div className='body'>
            <UserNameInput valueObj={{ inputValue: userNameInfo?.inputValue, countryCode: userNameInfo?.countryCode }} type={type} onChange={(val: any) => setUserNameInfo(val)} />
            <div className='tip-area'>
              {!correctAccount && type === 'email' && <span className='warn-span'>{i18n.t('mkt.common.tipEmail')}</span>}
              {!correctAccount && type === 'mobile' && <span className='warn-span'>{i18n.t('mkt.common.tipMobile')}</span>}
            </div>
          </div>
          {agreementJudge && <AgreementCheck checked={checked} onCheck={handleCheck} />}
          <div className='footer'>
            <MktButton text={i18n.t('mkt.common.gitVerCode')} disabled={!userNameInfo.valid} onClick={handleNext} />
          </div>
          <div className='extra'>
            <span className='reg-span' onClick={handleReg}>{i18n.t('mkt.common.passLoginReg')}</span>
          </div>
          {
            window.bo !== 'cn' && !!(ENV.googleAppId || ENV.facebookAppId) &&
              <>
                <div className='other'>
                  <div className='line'></div>
                  <span>{i18n.t('mkt.common.other')}</span>
                  <div className='line'></div>
                </div>
                <div className='type-content '>
                  {
                    !!ENV.googleAppId && (
                      <div className='type-item'>
                        <img src={ggImg} alt='' />
                        {
                          window.ODMINFO
                            ? (
                              <div className='type-block'>
                                <GoogleOAuthProvider clientId={ENV.googleAppId}>
                                  <GoogleLoginOuth2
                                    type='icon'
                                    onSuccess={(res: CredentialResponse) => {
                                      handleGgLogin(2, res)
                                    }}
                                    onError={loginError}
                                    useOneTap
                                  />
                                </GoogleOAuthProvider>
                              </div>
                            )
                            : (
                              <GoogleLoginOuth
                                clientId={ENV.googleAppId}
                                buttonText='Login'
                                onSuccess={(res: GoogleLoginResponse) => {
                                  handleGgLogin(1, res)
                                }}
                                onFailure={loginError}
                                cookiePolicy='single_host_origin'
                              />
                            )
                        }
                      </div>
                    )
                  }
                  {
                    !!ENV.facebookAppId && (
                      <div className='type-item'>
                        <img src={fbImg} alt='' />
                        <FacebookProvider appId={ENV.facebookAppId}>
                          <LoginButton
                            scope='email'
                            onCompleted={handleFbLogin}
                            onError={loginError}
                          >
                          </LoginButton>
                        </FacebookProvider>
                      </div>
                    )
                  }
                </div>
              </>
          }
        </div>
      </IonContent>
      <IonFooter>
        <div className='page-footer'>
          {window.bo !== 'cn' &&
            <div className='des'>
              <span>{i18n.t('mkt.common.tipPrivacy1')}</span>
              <span
                className='click-span' onClick={(e: any) => {
                  modalLayer(PrivacyAgreementModal, null, 'privacyAgreementModal')
                }}
              >{i18n.t('mkt.common.privacy')}
              </span>
              <span>{i18n.t('mkt.common.and')}</span>
              <span
                className='click-span' onClick={(e: any) => {
                  modalLayer(ServiceAgreementModal, null, 'serviceAgreementModal')
                }}
              >{i18n.t('mkt.common.service')}
              </span>
            </div>}
          <div className='agree'>
            <IonCheckbox
              className='checkbox' checked={keep} onClick={() => {
                setKeep(!keep)
                localStore.set(memberMobx.keepSignKey, keep ? 0 : 1)
                if (keep) {
                  sessionStorage.setItem(memberMobx.keepSignKey, '1')
                } else {
                  sessionStorage.removeItem(memberMobx.keepSignKey)
                }
              }}
            />
            <span>{i18n.t('mkt.login.keepSignIn')}</span>
            <div
              className='aggrement' onClick={(e: any) => {
                setShowPopover(true)
                setPopoverEvent(e)
              }}
            >
              {i18n.t('mkt.login.details')}
            </div>
          </div>
          <div className='support'><PowerByEShine /></div>
        </div>
      </IonFooter>
      <IonPopover
        cssClass='mkt-popover'
        event={popoverEvent}
        isOpen={showPopover}
        onDidDismiss={() => {
          setPopoverEvent(undefined)
          setShowPopover(false)
        }}
      >
        <div className='popver-con'>
          <div className='text'> {i18n.t('mkt.login.detailsDes')}</div>
          <div className='get'>
            <span onClick={() => {
              setPopoverEvent(undefined)
              setShowPopover(false)
            }}
            >{i18n.t('mkt.login.gotIt')}
            </span>
          </div>
        </div>
      </IonPopover>
    </IonPage>
  )
}

export default observer(Login)
